import React from "react";
import ColAtm from "../../atomic/Col/Col";
import { PageTitle } from "../../atomic/PageHeader/PageTitle";
import PageHeaderAtm from "../../atomic/PageHeader/PageHeader";
import {Link} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import {makeStyles} from "@material-ui/core/styles";
import {CircularProgress, Hidden} from "@material-ui/core";
import {
    APP,
    CONTENT,
    NETWORK,
    OFFER,
    WEB,
    PAYMENT_LIST,
    BOOKING_ENGINE,
    PAYMENT_TRANSACTION_LIST,
    PAYMENT_CREATE, NOT_ALLOWED_DASHBOARD_SHORT,
    NETWORK_COMPETITOR,
    REPUTATION_MANAGEMENT_REVIEWS,
    REPUTATION_MANAGEMENT_SCORES,
    REPUTATION_MANAGEMENT, NETWORK_COMPETITOR_DASH
} from "../../../constants/appUrls.constants";
import BottomNavigation from "@material-ui/core/BottomNavigation/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import { history } from "../../../utils/history";
import CssBaseline from "@material-ui/core/CssBaseline";
import Card from "@material-ui/core/Card";
import Box from "@material-ui/core/Box";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getPaymentDashboard} from "../../../redux/actions/Payment/PaymentDashboard.actions";
import {getPropertyName, isDefined} from "../../../utils";
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import NotAllowedPage from "../Global/NotAllowedPage/NotAllowedPage";
import { propertyProducts } from "../../../redux/actions/propertyProductsActions";
import { 
    reputationManagementReview, reputationManagementReviewStatistics, 
    reputationManagementList, reputationManagementSync,
    reputationManagementListClear, reputationManagementSyncClear
 } from "../../../redux/actions/Network/ReputationManagement/ReputationManagement.actions";
import Charts from "../Global/Charts";
import ChannelSetupModal from "./ChannelSetupModal";
import {Snackbar} from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import { getProperty } from "../../../utils";

import DashboardBottomActions from "../../molecules/DashboardBottomActions/DashboardBottomActions";
import {getProfile} from "../../../redux/actions/User/Profile/profileAction";
let t=null;

const drawerWidth = 91;
const drawerWidthCollapsed = 280;
const drawerWidthExpanded = 280;
const leftMenuWidth = 252;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'block',
        width: '100%',
    },
    drawer: {
        width: drawerWidthCollapsed,
        flexShrink: 0,
        zIndex: '999',
    },
    leftMenu: {
        width: 0,
        flexShrink: 0,
    },
    leftMenuPaper: {
        width: leftMenuWidth,
        marginLeft: 102,
        marginTop: 81
    },
    drawerPaper: {
        width: drawerWidthCollapsed,
        height: 'calc(100vh - 81px)',
        marginTop: '81px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        borderRight: '1px solid #e2e8f0',
        padding: '20px 12px',
        overflowX: 'hidden',
        overflowY: 'auto',
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d1d5db',
            borderRadius: 4,
        },
        '@media (min-width: 960px) and (max-width: 1600px)': {
            height: 'calc(125vh - 101px)',
            minHeight: 'calc(125vh - 101px)',
        },
    },
    sidebarList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        flex: '1 1 auto',
    },
    sidebarLink: {
        textDecoration: 'none',
        display: 'block',
        marginBottom: 8,
        '&:focus': {
            outline: 'none',
        },
    },
    sidebarItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '12px 12px',
        borderRadius: 47,
        cursor: 'pointer',
        transition: 'background 0.2s ease',
        background: 'transparent',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        '&:hover': {
            background: '#f1f5f9',
        },
    },
    sidebarItemActive: {
        background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        '&:hover': {
            background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        },
    },
    sidebarIconWrapper: {
        minWidth: 34,
        width: 34,
        height: 34,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    sidebarIcon: {
        fontSize: 18,
        color: '#64748b',
        transition: 'color 0.2s ease',
    },
    sidebarIconActive: {
        color: '#fff',
    },
    sidebarText: {
        fontSize: 13,
        fontWeight: 600,
        color: '#475569',
        marginLeft: 14,
        opacity: 1,
        transition: 'opacity 0.2s ease 0.1s',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        pointerEvents: 'none',
    },
    sidebarTextVisible: {
        opacity: 1,
    },
    sidebarTextActive: {
        color: '#fff',
    },
    sidebarDivider: {
        height: 1,
        background: '#e2e8f0',
        margin: '10px 8px',
        transition: 'margin 0.3s ease',
        '$drawerPaper:hover &': {
            margin: '10px 12px',
        },
    },
    chartsWrapper: {
        flex: '0 0 auto',
        padding: '16px 0',
        borderTop: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    leftBarShift: {
        width: `calc(100% - ${leftMenuWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
        backgroundColor: '#ffffff',
        padding: '11px 12.14px'
    },
    hide: {
        display: 'none',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 125,
        marginRight: -60,
        paddingRight: 120,
    },
    content: {
        flexGrow: 1,
        padding: '24px 68px',
    },
    toolbar: theme.mixins.toolbar,
}));

function AlertSnackbar(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class ReputationDashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSuccessHeader: false,
            open : false,
            open_preview: false,
            copied: false,
            channelModalOpen: false,
        };
        t = props.t;
    }

    handleClickOpen = () => {
        this.setState({open:true});
    };

    handleClickOpenPreview = () => {
        this.setState({open_preview:true});
    };

    handleClose = () => {
        this.setState({open:false, open_preview:false});
    };

    handlePreviewClose = () => {
        this.setState({open_preview:false});
    };

    componentDidMount() {
        // Sol menüdeki Panel / Site Ayarları butonları profil e-postasına bakıyor
        this.props.getProfile();
        document.body.style.backgroundColor = "#f4f7fc";
        this.props.propertyProducts();

        // Dashboard sağ box verileri
        this.props.reputationManagementReview({ page: 1, per_page: 100 });
        this.props.reputationManagementReviewStatistics();

        this.props.reputationManagementList();
    }

    componentDidUpdate(prevProps) {
        // Sync success
        if (this.props.syncData && this.props.syncData !== prevProps.syncData) {
            this.props.reputationManagementList();
            this.setState({
                // channelModalOpen: false,
                snackbarOpen: true,
                snackbarMessage: this.props.t("enw-reputation_management-channel_saved"),
                snackbarSeverity: "success",
            });
            // setTimeout(() => {
            //     this.setState({
            //         channelModalOpen: false,
            //     });
            // }, 500);
            this.props.reputationManagementSyncClear();
        }

        // Sync error
        if (this.props.syncError && this.props.syncError !== prevProps.syncError) {
            const msg =
                this.props.syncError?.response?.data?.message ||
                this.props.t("enw-error-message");

            this.setState({
                snackbarOpen: true,
                snackbarMessage: msg,
                snackbarSeverity: "error",
            });
            this.props.reputationManagementSyncClear();
        }
    }

    componentWillUnmount() {
        this.props.reputationManagementListClear();
        this.props.reputationManagementSyncClear();
    }

    handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") return;
        this.setState({ snackbarOpen: false });
    };

    handleChannelModalClose = () => {
        this.setState({ channelModalOpen: false });
        this.props.reputationManagementSyncClear();
    };

    handleChannelModalOpen = () => {
        this.setState({ channelModalOpen: true });
    };
    handleChannelModalClose = () => {
        this.setState({ channelModalOpen: false });
        this.props.reputationManagementSyncClear();
    };

    handleChannelSave = (params) => {
        this.props.reputationManagementSync(params);
    };

    headerStatusShow = () =>{
        return  <PageHeaderAtm backButton={APP}
                               exitText={ t('btn-properties')}
                               text={ getPropertyName() }
                               showSuccessHeader={this.props.createStatus}
        />
    };

    render() {

        const allowedPage = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "payment" === item.route)

        const allowedPageNetwork = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "network" === item.route)

        const allowedPageOffer = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "offer" === item.route)

        const allowedPageWeb = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "web" === item.route)

        const allowedPageBookingEngine = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "booking-engine" === item.route)

        const allowedPagePayment = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "payment" === item.route)

        const propertyProductCompetitor = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route)

        const allowedPageReputationManagement = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "reputation-management" === item.route)

        
        function Sidebar(props) {
            const classes = useStyles();
            const [isExpanded, setIsExpanded] = React.useState(false);
            const hoverTimeoutRef = React.useRef(null);
            const isNavigatingRef = React.useRef(false);

            const handleMouseEnter = () => {
                if (isNavigatingRef.current) return;
                
                if (hoverTimeoutRef.current) {
                    clearTimeout(hoverTimeoutRef.current);
                }
                setIsExpanded(true);
            };

            const handleMouseLeave = () => {
                if (hoverTimeoutRef.current) {
                    clearTimeout(hoverTimeoutRef.current);
                }
                hoverTimeoutRef.current = setTimeout(() => {
                    if (!isNavigatingRef.current) {
                        setIsExpanded(false);
                    }
                }, 100);
            };

            const handleLinkClick = (e) => {
                isNavigatingRef.current = true;
                
                const currentExpanded = isExpanded;
                
                setTimeout(() => {
                    isNavigatingRef.current = false;
                    setIsExpanded(currentExpanded);
                }, 500);
            };

            // Cleanup
            React.useEffect(() => {
                return () => {
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                    }
                };
            }, []);

            const sidebar = (
                <div className={classes.root}>
                    <Drawer
                        className={classes.drawer}
                        variant="permanent"
                        classes={{
                            paper: classes.drawerPaper + " left-sidebar",
                        }}
                        PaperProps={{
                            onMouseEnter: handleMouseEnter,
                            onMouseLeave: handleMouseLeave,
                            style: {
                                width: isExpanded ? drawerWidthExpanded : drawerWidthCollapsed,
                            },
                        }}
                    >
                        <List className={classes.sidebarList}>
                            {props.siderbarItems.map((post, key) => (
                                <React.Fragment key={key}>
                                    <Link 
                                        to={post.link} 
                                        className={classes.sidebarLink}
                                        onClick={handleLinkClick}
                                    >
                                        <Box 
                                            className={`${classes.sidebarItem} ${post.isActive ? classes.sidebarItemActive : ''}`}
                                        >
                                            <Box className={classes.sidebarIconWrapper}>
                                                <i 
                                                    className={`${post.icon} ${classes.sidebarIcon} ${post.isActive ? classes.sidebarIconActive : ''}`} 
                                                />
                                            </Box>
                                            <Typography 
                                                className={`${classes.sidebarText} ${post.isActive ? classes.sidebarTextActive : ''} ${isExpanded ? classes.sidebarTextVisible : ''}`}
                                            >
                                                {post.text}
                                            </Typography>
                                        </Box>
                                    </Link>
                                </React.Fragment>
                            ))}
                        </List>
                        {/* Panel + Site Ayarları: logonun üstünde */}
                        <DashboardBottomActions />

                        <Box className={classes.chartsWrapper}>
                            <Charts />
                        </Box>
                    </Drawer>
                </div>
            );
            return (
                <>
                    {sidebar}
                </>
            );
        }
        const siderbarItems = [
            {id: 1, isActive: false, text: `${ t('enw-product_one-title') }`, icon: 'fas fa-hotel', link:"content"},
            {id: 4, isActive: false, text: `${t('enw-product_four-title') }`, icon: 'fas fa-network-wired', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? "web" : NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#"},
            {id: 5, isActive: false, text: `${t('enw-product_six-title')}`, icon: 'fas fa-calendar-alt', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? "booking-engine" : NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#"},
            {id: 6, isActive: false, text: `${t('enw-product_five-title') }`, icon: 'fas fa-money-bill-wave-alt', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? "payment" : NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#"},
            {id: 3, isActive: false, text: `${t('enw-product_three-title') }`, icon: 'fas fa-paperclip', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? "offer" : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#"},
            {id: 2, isActive: false, text: `${t('enw-product_two-title') }`, icon: 'fas fa-chart-network', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? "network" : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#"},
            {id: 7, isActive: false, text: (
                <>
                    {t('enw-input-competitor')}
                    <span className="newBadge">{t('enw-new_title')}</span>
                </>
            ), icon: 'fas fa-analytics', link: NETWORK_COMPETITOR_DASH },
            {id: 8, isActive: true, text: (
                    <>
                        {t('enw-reputation_management-title')}
                        <span className="newBadge">{t('enw-new_title')}</span>
                    </>
            ), icon: 'fas fa-comments-alt', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#" },
        ];
        
        const { propertyProductsReducer, reviewData, reviewFetching, statisticsData, statisticsFetching } = this.props;
        const { channelModalOpen, snackbarOpen, snackbarMessage, snackbarSeverity } = this.state;
        const { channelListData, syncFetching, syncData, syncError } = this.props;
        
        const totalReviews = statisticsData?.dashboard?.total?.count || "-";
        const totalReviewsCount = statisticsData?.dashboard?.total?.extraReviewCount ?? null;

        const positiveReviews =  statisticsData?.dashboard?.positive?.count || '-';
        const positiveReviewsCount =  statisticsData?.dashboard?.positive?.extraReviewCount ?? null;

        const negativeReviews = statisticsData?.dashboard?.negative?.count || '-';
        const negativeReviewsCount = statisticsData?.dashboard?.negative?.extraReviewCount ?? null;

        let mostCommentedScoreName = statisticsData?.dashboard?.best?.language_key ?? statisticsData?.dashboard?.best?.name ?? null; 
        let mostCommentedScore = statisticsData?.dashboard?.best?.positive ?? '-';

        return (
            <>
                <PageTitle title={ t('enw-reputation_management-title') } />
                {
                    this.headerStatusShow()
                }

                <Grid container className="payment-dashboard rm-dash-main">
                    <Grid item md={1} className="m-none" style={{ height: 'fit-content'}}>
                        <Sidebar siderbarItems={siderbarItems} />
                    </Grid>
                    <Grid item xs={12} className="m-auto web-dashboard">
                        <div>
                            <CssBaseline />
                            {
                                isDefined(allowedPageReputationManagement[0]) && !allowedPageReputationManagement[0].property_has_product ?
                                    <Grid item xs={12} lg={6} className="no-buy-product">
                                        <Card className="p-24">
                                            <NotAllowedPage />
                                        </Card>
                                    </Grid>
                                    :
                                    <Grid container spacing={3} className="mt-44 be-container-width">
                                        <Grid item xs={12} sm={8} lg={7} className="m-auto web-stats be-dashboard-items">
                                            <Grid container spacing={3}>
                                                <Grid item md={7} xs={12} className="m-auto pt-20">
                                                    <Hidden xsDown>
                                                        <Card className="offer-dashboard__box-shadow" item xs={12}>
                                                            <Box className="offer-dashboard bg-icon-purple" component="fieldset" mb={3} borderColor="transparent">
                                                                <i className="fas fa-comments-alt purple" />
                                                            </Box>
                                                            <CardContent className="min-height-153 pt-0 pr-24 pl-24">
                                                                <ColAtm>
                                                                    <ColAtm md={8} xl={9}>
                                                                        <Typography className="purple pb-12" gutterBottom variant="h5" component="h2">
                                                                            { t('enw-reputation_management-title') }
                                                                        </Typography>
                                                                    </ColAtm>
                                                                </ColAtm>
                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                    { t('enw-reputation_management-dashboard-subdesc') }
                                                                </Typography>
                                                            </CardContent>
                                                            <ColAtm className="carousel-col general-carousel offer-block-tabs">
                                                                <Link to={"#"} onClick={(e) => { e.preventDefault(); this.handleChannelModalOpen(); }}> { t('enw-reputation_management-channel_setup') } </Link>
                                                                <Link to={REPUTATION_MANAGEMENT_SCORES}> { t('enw-reputation_management_scores-title') } </Link>
                                                                <Link to={REPUTATION_MANAGEMENT_REVIEWS}> { t('myweb-section-google_reviews') } </Link>
                                                            </ColAtm>
                                                        </Card>
                                                    </Hidden>
                                                    <Hidden smUp>
                                                        <Card className="offer-dashboard__box-shadow mobile-mb-0 mb-24" item xs={12}>
                                                            <Card>
                                                                <Grid container spacing={3}>
                                                                    <ColAtm>
                                                                        <ColAtm className="bg-icon-purple m-rm-dashboard" item xs={4}>
                                                                            <i className="fas fa-comments-alt purple" />
                                                                        </ColAtm>
                                                                        <ColAtm item xs={8} className="border-shadow">
                                                                            <CardContent className="w-100">
                                                                                <ColAtm>
                                                                                    <ColAtm xs={12}>
                                                                                        <Typography variant="h6" className="purple rm-m-fs-18" style={{fontWeight: 600}} gutterBottom noWrap>
                                                                                            { t('enw-reputation_management-title') }
                                                                                        </Typography>
                                                                                    </ColAtm>
                                                                                </ColAtm>
                                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                                    { t('enw-reputation_management-dashboard-subdesc') }
                                                                                </Typography>
                                                                            </CardContent>
                                                                        </ColAtm>
                                                                    </ColAtm>
                                                                    <ColAtm className="carousel-col general-carousel offer-block-tabs">
                                                                        <Carousel slidesPerPage={2}
                                                                                  infinite
                                                                                  keepDirectionWhenDragging
                                                                                  arrowLeft={<i className="fas fa-caret-left" />}
                                                                                  arrowRight={<i className="fas fa-caret-right" />}
                                                                                  addArrowClickHandler
                                                                                  arrows
                                                                        >
                                                                            <Link key={0} to={"#"} onClick={(e) => { e.preventDefault(); this.handleChannelModalOpen(); }}> { t('enw-reputation_management-channel_setup') } </Link>
                                                                            <Link key={1} to={REPUTATION_MANAGEMENT_SCORES}> { t('enw-reputation_management_scores-title') } </Link>
                                                                            <Link key={2} to={REPUTATION_MANAGEMENT_REVIEWS}> { t('myweb-section-google_reviews') } </Link>
                                                                        </Carousel>
                                                                    </ColAtm>
                                                                </Grid>
                                                            </Card>
                                                        </Card>
                                                    </Hidden>
                                                </Grid>
                                                <Grid item md={5} xs={12} className="m-auto">
                                                    <Grid container spacing={3} className="mobile-offer-boxes-padding">
                                                        <Grid item xs={6}>
                                                            <Paper className="offer-boxes">
                                                                <ColAtm sm={12} className="pt-26">
                                                                    <i className="fas fa-comments-alt green fs-22 bg-icon-green m-auto b-r-50" />
                                                                </ColAtm>
                                                                <ColAtm sm={12}>
                                                                    <span className="payment-info-text m-auto f-w-bold">
                                                                        {reviewFetching ? <CircularProgress className="rm-circular-progress" color="secondary" /> : <>{totalReviews}</>}
                                                                    </span>
                                                                </ColAtm>
                                                                <ColAtm sm={12}>
                                                                    <span className="offer-total-title"> {t('enw-reputation_management-total_reviews')} </span>
                                                                </ColAtm>
                                                                {
                                                                    totalReviewsCount && totalReviewsCount !== 0 ?
                                                                    <ColAtm justify={"center"} sm={12}>
                                                                        <span style={{ color: "#4caf50", fontSize: 14 }}>+{totalReviewsCount}</span>
                                                                    </ColAtm> : ""
                                                                }
                                                            </Paper>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Paper className="offer-boxes">
                                                                <ColAtm sm={12} className="pt-26">
                                                                    <i className="far fa-thumbs-up green fs-22 bg-icon-green m-auto b-r-50" />
                                                                </ColAtm>
                                                                <ColAtm sm={12}>
                                                                    <span className="payment-info-text m-auto f-w-bold">
                                                                        {statisticsFetching ? <CircularProgress className="rm-circular-progress" color="secondary" /> : <>{positiveReviews}</>}
                                                                    </span>
                                                                </ColAtm>
                                                                <ColAtm sm={12}>
                                                                    <span className="offer-total-title"> {t('enw-reputation_management-positive_total_scores')} </span>
                                                                </ColAtm>
                                                                {
                                                                    positiveReviewsCount && positiveReviewsCount !== 0 ?
                                                                    <ColAtm justify={"center"} sm={12}>
                                                                        <span style={{ color: "#4caf50", fontSize: 14 }}>+{positiveReviewsCount}</span>
                                                                    </ColAtm> : ""
                                                                }
                                                            </Paper>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Paper className="offer-boxes">
                                                                <ColAtm sm={12} className="pt-26">
                                                                    <i className="far fa-thumbs-down red fs-22 bg-icon-red m-auto b-r-50" />
                                                                </ColAtm>
                                                                <ColAtm sm={12}>
                                                                    <span className="payment-info-text m-auto f-w-bold">
                                                                        {statisticsFetching ? <CircularProgress className="rm-circular-progress" color="secondary" /> : <>{negativeReviews}</>}
                                                                    </span>
                                                                </ColAtm>
                                                                <ColAtm sm={12}>
                                                                    <span className="offer-total-title"> {t('enw-reputation_management-negative_total_scores')} </span>
                                                                </ColAtm>
                                                                {
                                                                    negativeReviewsCount && negativeReviewsCount !== 0 ?
                                                                    <ColAtm justify={"center"} sm={12}>
                                                                        <span style={{ color: "#4caf50", fontSize: 14 }}>+{negativeReviewsCount}</span>
                                                                    </ColAtm> : ""
                                                                }
                                                            </Paper>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Paper className="offer-boxes">
                                                                <ColAtm sm={12} className="pt-26">
                                                                    <i className="fas fa-star blue fs-22 bg-icon-blue m-auto b-r-50" />
                                                                </ColAtm>
                                                                <ColAtm sm={12}>
                                                                    <span className="payment-info-text m-auto f-w-bold">
                                                                        {statisticsFetching ? <CircularProgress className="rm-circular-progress" color="secondary" /> : <>{mostCommentedScore === 0 ? '-' : mostCommentedScore}</>}
                                                                    </span>
                                                                </ColAtm>
                                                                <ColAtm sm={12}>
                                                                    <span className="offer-total-title">
                                                                        {t('enw-reputation_management-most_commented_score')}
                                                                    </span>
                                                                </ColAtm>
                                                                <ColAtm sm={12}>
                                                                    <span className="offer-total-title" style={{ color: "#1976d2", fontSize: 14, fontWeight: 500 }}>
                                                                        {t(mostCommentedScoreName)}
                                                                    </span>
                                                                </ColAtm>
                                                            </Paper>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                            }
                        </div>
                    </Grid>
                </Grid>
                <Hidden mdUp>
                    <BottomNavigation className="m-navigation" value="reputation-management">
                        <BottomNavigationAction value="content" icon={<i className="fas fa-hotel" />} onClick={() => { history.push(CONTENT)}}  />
                        <BottomNavigationAction value="web" icon={<i className="fas fa-network-wired" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? WEB :  NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#")}} />
                        <BottomNavigationAction value="booking" icon={<i className="fas fa-calendar-alt" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? BOOKING_ENGINE :  NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#")}} />
                        <BottomNavigationAction value="payment" icon={<i className="fas fa-money-bill-wave-alt" />} />
                        <BottomNavigationAction value="offer" icon={<i className="fas fa-paperclip" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? OFFER : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#")}} />
                        <BottomNavigationAction value="network" icon={<i className="fas fa-chart-network" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? NETWORK : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#" )}} />
                        <BottomNavigationAction value="competitor-analysis" icon={<i className="fas fa-analytics" />} onClick={() => { history.push(NETWORK_COMPETITOR_DASH) }} />
                        <BottomNavigationAction
                            value="reputation-management"
                            icon={<i className="fas fa-comments-alt" />}
                            onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#")}}
                        />
                    </BottomNavigation>
                </Hidden>

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={this.handleSnackbarClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                >
                    <AlertSnackbar onClose={this.handleSnackbarClose} severity={snackbarSeverity}>
                        {snackbarMessage}
                    </AlertSnackbar>
                </Snackbar>

                <ChannelSetupModal
                    open={channelModalOpen}
                    onClose={this.handleChannelModalClose}
                    channels={channelListData}
                    onSave={this.handleChannelSave}
                    syncFetching={syncFetching}
                    syncData={syncData}
                    syncError={syncError}
                />
                <style>{`
                    .rm-circular-progress {
                        position: relative !important;
                    }
                    @media screen and (max-width: 768px) {
                        .dashboard-tools > div:nth-last-child(-n + 2) {
                            margin-top:5px !important;
                        }
                    }
                    .MuiDrawer-paper::-webkit-scrollbar {
                        width: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-track {
                        background: transparent;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb {
                        background: #d1d5db;
                        border-radius: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb:hover {
                        background: #9ca3af;
                    }

                    @media (min-width: 960px) and (max-width: 1600px) {
                        .MuiDrawer-paper {
                            height: calc(125vh - 81px) !important;
                            min-height: calc(125vh - 101px) !important;
                        }
                        
                        .sidebar-items, .active-sidebar {
                            padding: 10px 14px !important;
                        }
                        
                        .sidebar-items i,
                        .active-sidebar i {
                            font-size: 16px !important;
                        }
                        
                        .dashboard-menu {
                            font-size: 12px !important;
                        }
                    }

                    .MuiDrawer-paper {
                        &:hover {
                            .sidebar-text-animated {
                                opacity: 1 !important;
                                transform: translateX(0) !important;
                            }
                        }
                    }
                    @media screen and (max-width: 400px) {
                        .web-stats .offer-boxes {
                            min-height:180px !important
                        }
                    }
                `}</style>
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    propertyProductsReducer: state.propertyProductsReducer,
    reviewData: state.reputationManagementReducer?.reviewData,
    reviewFetching: state.reputationManagementReducer?.reviewFetching,
    statisticsData: state.reputationManagementReducer?.reviewStatisticsData,
    statisticsFetching: state.reputationManagementReducer?.reviewStatisticsFetching,

    // Modal için
    channelListData: state.reputationManagementReducer?.listData,
    channelListFetching: state.reputationManagementReducer?.listFetching,
    syncData: state.reputationManagementReducer?.syncData,
    syncFetching: state.reputationManagementReducer?.syncFetching,
    syncError: state.reputationManagementReducer?.syncError,
});

const mapDispatchToProps = {
    getProfile,
    propertyProducts,
    reputationManagementReview,
    reputationManagementReviewStatistics,

    // Modal için
    reputationManagementList,
    reputationManagementSync,
    reputationManagementListClear,
    reputationManagementSyncClear
};

export default compose(withTranslation('common'))(
    connect(mapStateToProps, mapDispatchToProps)(ReputationDashboard)
);